export enum NewContractDurationUnit {
  Month = 1,
  Year = 2,
}